import { Td, Tr } from '@chakra-ui/react';
import { columnTypeToFormatter } from './columns';

const ApplicationsRow = ({ columns, row }) => {
  return (
    <Tr>
      {columns.map((column) => {
        const value = column.render ? column.render(row) : row[column.key];

        const formatter = column.type && columnTypeToFormatter[column.type];
        const formattedValue = formatter ? formatter(value) : value;

        return (
          <Td flex={1} key={column.label}>
            {formattedValue}
          </Td>
        );
      })}
    </Tr>
  );
};

export default ApplicationsRow;
